import { Component, ViewChild, OnInit, AfterViewInit, Inject } from '@angular/core';
import { HttpClient, HttpRequest, HttpEventType, HttpResponse, HttpErrorResponse, HttpParams } from '@angular/common/http'
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MessageService } from '../../core/services/message.service';
import { ApiService } from '../../core/services/api.service';
import { AsideComponent } from '../aside/aside.component';
import { AuthorizationEnum } from '../../enums/authorization-enum';
import { LoadInfo } from './shared/load-info';
import { FileSystemFileEntry, FileSystemDirectoryEntry, UploadEvent } from 'ngx-file-drop';
import { DataTableComponent } from '../../shared/data-table/data-table.component';
import { Address } from 'src/app/Models/address';
import { UpdateAddressModalComponent } from '../dialogs/dialog-update-address/dialog-update-address.component';
import * as printJS from '../../../../node_modules/print-js/src/index.js';
import { Order } from 'src/app/Models/order';
import { UserDto } from '../../dtos/user-dto';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.scss']
})
export class UploadFileComponent implements OnInit, AfterViewInit {
  options = {
    columnTitles: ["LOAD_IMPORT.TABLE.LOAD_ID", "LOAD_IMPORT.TABLE.DATE", "LOAD_IMPORT.TABLE.UNITS", "LOAD_IMPORT.TABLE.ACTIONS"],
    columnReferences: ["id", "date", "units", "actions"],
    actionButtons: { detail: true }
  }
  withPending = false;
  replenishment = false;
  public progress: number;
  public message: string;
  public authorizationType: AuthorizationEnum;
  public authorizationEnum = AuthorizationEnum;
  @ViewChild("tableChild") tableChild: DataTableComponent<LoadInfo>;
  openAside: boolean;
  selectedLoad: any;

  @ViewChild(AsideComponent)
  aside: AsideComponent;

  selectedFile: any;
  fileSize: any;

  constructor(private apiService: ApiService, private messageService: MessageService, public dialog: MatDialog) {
    this.getUser();
  }

  ngOnInit(): void {
    
  }

  ngAfterViewInit(): void {
    /*let test = [];

    for(let i = 0 ; i < 73; i++){
      test.push({id: i, zipCode: 85160, city: 'Obregon', neighborhood: 'Campestre', street: 'Mariano', extNumber: 170});
    }

    setTimeout(() => {
      this.openDialogAddress(test);
    }, 100);*/ // Desbloquear para simular
  }
  getUser() {
    let userStorage = localStorage.getItem('currentUser');
    if (userStorage) {
      let user: UserDto = JSON.parse(userStorage);
      if (user) {
        this.authorizationType = user.auth;
      }
    }
  }
  upload(files) {
    if (files.length === 0)
      return;

    this.selectedFile = files[0];
    this.fileSize = this.formatBytes(this.selectedFile.size, 2);
    
  }

  sendFile() {
    const formData = new FormData();
    formData.append(this.selectedFile.name, this.selectedFile);

    this.apiService.post("api/Upload/" + this.withPending + "/" + this.replenishment, formData).subscribe((response: Address[]) => {
      this.messageService.success('GENERAL.MESSAGE.TITLE_SUCCESS', 'GENERAL.MESSAGE.SUCCESS',
      {
        article: 'GENERAL.MESSAGE.THE_1',
        function: 'LOAD_IMPORT.SINGLE',
        action: 'GENERAL.MESSAGE.ACTIONS.ACTION_SAVE'
      });      
      this.tableChild.loadPage();
      if(response && response.length) {
        this.openDialogAddress(response);
      }
    });
  }

  openDialogAddress(address: Address[]) {
    const dialogRef = this.dialog.open(UpdateAddressModalComponent, {
      width: '1280px',
      data: address,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      
    });
  }

  openDetail(load: any) {
    let params: HttpParams = new HttpParams();
    params = params.append("id", load.id.toString());

    this.apiService.get("api/load/" + load.id + "/detail").subscribe(event => {
      this.selectedLoad = event.data;
      this.openDialog();
    }, error => {
      this.messageService.handleError(error, 8000);
    });
  }

  public dropped(event: UploadEvent) {
    let droppedFile = event.files[0];
    // Is it a file?
    if (droppedFile.fileEntry.isFile) {
      const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
      fileEntry.file((file: File) => {
        console.log(droppedFile.relativePath, file);
        this.selectedFile = file;
        this.fileSize = this.formatBytes(this.selectedFile.size, 2);
        console.log(this.selectedFile);
      });
    } else {
      const fileEntry = droppedFile.fileEntry as FileSystemDirectoryEntry;
      console.log(droppedFile.relativePath, fileEntry);
    }
  }

  formatBytes(a, b) {
    if (0 == a) return "0 Bytes";
    var c = 1024,
      d = b || 2,
      e = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
      f = Math.floor(Math.log(a) / Math.log(c));
    return parseFloat((a / Math.pow(c, f)).toFixed(d)) + " " + e[f]
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(LoadDetailModal, {
      width: '1280px',
      data: this.selectedLoad
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }

}

@Component({
  selector: 'detail-modal',
  templateUrl: 'detail-modal.html',
  styleUrls: ['./upload-file.component.scss']
})
export class LoadDetailModal {
  constructor(
    public dialogRef: MatDialogRef<LoadDetailModal>,
    private apiService: ApiService,
    private messageService: MessageService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any) { }
    data_printable : any;
    selection = [];
    session = JSON.parse(localStorage.getItem("currentUser"));
    generalSelection = false;
    onNoClick(): void {
      this.dialogRef.close();
    }

  openDialog(): void {
    const dialogRef = this.dialog.open(LoadPdfModal, {
      width: '1280px',
      data: {"printable":this.data_printable,"selection":this.selection},
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }

  changeSelection(tableData:any){
    for(let i = 0;i<this.data.ships.length;i++){
        this.data.ships[i].selected = this.generalSelection;
    }
    console.log(this.data.ships);
  }

  saveLabels(data){
    this.selection = [];
    data.forEach(element => {
      if(element.selected){
        this.selection.push({"IdShip":element.shipId,"UserName":this.session.username});
      }
    });
    this.apiService.post('api/OrderPrint/createLabel',this.selection).subscribe((response: any) => {
      let Orders_string = "";
      response.data.forEach(element => {
        if(element.success){
          Orders_string+= (element.order+",");
        }
      });
      Orders_string = Orders_string.substr(0,Orders_string.length-1);
      if(Orders_string.length>0){
        this.messageService.success("Generación Exitosa","Códigos Generados: "+Orders_string);
      }else{
        this.messageService.error("Generación Fallida","La orden ya existe");
      }
    })
  }

  printLabels(data){
    this.selection = [];
    data.forEach(element => {
      if(element.selected){
        this.selection.push(element.shipId);
      }
    });
    this.apiService.post('api/OrderPrint/Print',this.selection).subscribe((response: any) => {
      this.data_printable = response;
      this.openDialog();
    })
  }

}

@Component({
  selector: 'detail-pdf',
  templateUrl: 'detail-pdf.html',
  styleUrls:['./upload-file.component.scss']
})
export class LoadPdfModal{
  cont_data:any;
  safe_pdf_url:SafeResourceUrl;
  constructor(private apiService: ApiService,
     public dialogRef: MatDialogRef<LoadPdfModal>,
     private messageService: MessageService,
     public dialog: MatDialog,
     private sanitizer: DomSanitizer,
     @Inject(MAT_DIALOG_DATA) public data: any
    ) {
      this.cont_data = data.printable;
      this.safe_pdf_url = this.sanitizer.bypassSecurityTrustResourceUrl(this.cont_data.data);
    }

    onNoClick(): void {
      this.dialogRef.close();
    }

  sendPrintableResponse(accept:boolean){
    /*this.apiService.post('api/OrderPrint/Print?accept='+accept,this.selection).subscribe((response: any) => {
      this.dialogRef.close();
    })*/
    if(accept){
      var w = window.open(this.cont_data.data);
      w.onload = function () {
        w.print();
      };
      return false;

      // printJS(this.cont_data.data);
    }else{
      this.dialogRef.close();
    }
  }
}
